<template>
  <div id="app">
    <!-- <sz-header
      name="head"
      v-if="isWeb"
    ></sz-header> -->
    <router-view />
    <!--<sz-footer :name="`${'copy'}right`"></sz-footer>-->
  </div>
</template>

<script>
(function () {
    var icon = document.createElement("link");
    icon.type = "image/x-icon";
    icon.rel = "shortcut icon";
    icon.href = "/fa_static/favicon.ico";
    document.getElementsByTagName("head")[0].appendChild(icon);
})();
console.log('配置',process.env.NODE_ENV)
// import szHeader from '@/components/web/szHeader'; // 顶部
import 'weui/dist/style/weui.min.css'; // weui样式
import { getCookie, getSzpl, isMobile, getUa } from '@/module/tools'; // 添加工具
export default {
  name: 'App',
  components: {
   
  },
  data() {
      return {
          isWeb: false,
          shareStore: this.$store.state,
      }
  },
  created() {
    if(!isMobile()){
        this.isWeb = true;
    }
    this.initStoreState()
    this.initSensors()
  },
  mounted () {

     
  },
  methods:{
    initStoreState () {
      this.$store.commit('setIsLogin', getCookie('islogin') === '1')
    },
    // 神策埋点添加初始化内容
    initSensors () {
      if (this.shareStore.isLogin) {
        // 只有有手机号的时候才会去登录
        this.$store.state.szMemberCode && this.$sa.login(this.$store.state.szMemberCode)
      }else {
        this.$sa.logout(true)
      }
      this.$sa.registerPage({
        is_login: !!(this.shareStore.isLogin && this.$store.state.szMemberCode)
      })
    }
  }
}
</script>

<style lang="scss">
@import "./scss/sz/common/reset";
</style>
